(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[729,4666],{

/***/ 264666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(263366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(487462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(490512);
/* harmony import */ var _mui_utils_composeClasses__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(615463);
/* harmony import */ var _mui_utils_useId__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(410414);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(998216);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(496664);
/* harmony import */ var _Fade__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16628);
/* harmony import */ var _Paper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(690629);
/* harmony import */ var _DefaultPropsProvider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(167023);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(690948);
/* harmony import */ var _dialogClasses__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(477620);
/* harmony import */ var _DialogContext__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(434182);
/* harmony import */ var _Backdrop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(884808);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(202734);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);
'use client';



const _excluded = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
















const DialogBackdrop = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_Backdrop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
  name: 'MuiDialog',
  slot: 'Backdrop',
  overrides: (props, styles) => styles.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
});
const useUtilityClasses = ownerState => {
  const {
    classes,
    scroll,
    maxWidth,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ['root'],
    container: ['container', `scroll${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(scroll)}`],
    paper: ['paper', `paperScroll${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(scroll)}`, `paperWidth${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(String(maxWidth))}`, fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
  };
  return (0,_mui_utils_composeClasses__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(slots, _dialogClasses__WEBPACK_IMPORTED_MODULE_6__/* .getDialogUtilityClass */ .D, classes);
};
const DialogRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_Modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
  name: 'MuiDialog',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  '@media print': {
    // Use !important to override the Modal inline-style.
    position: 'absolute !important'
  }
});
const DialogContainer = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)('div', {
  name: 'MuiDialog',
  slot: 'Container',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.container, styles[`scroll${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ownerState.scroll)}`]];
  }
})(({
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
  height: '100%',
  '@media print': {
    height: 'auto'
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, ownerState.scroll === 'body' && {
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  '&::after': {
    content: '""',
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    width: '0'
  }
}));
const DialogPaper = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_Paper__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
  name: 'MuiDialog',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`scrollPaper${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ownerState.scroll)}`], styles[`paperWidth${(0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
  }
})(({
  theme,
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
  margin: 32,
  position: 'relative',
  overflowY: 'auto',
  // Fix IE11 issue, to remove at some point.
  '@media print': {
    overflowY: 'visible',
    boxShadow: 'none'
  }
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100% - 64px)'
}, ownerState.scroll === 'body' && {
  display: 'inline-block',
  verticalAlign: 'middle',
  textAlign: 'left' // 'initial' doesn't work on IE11
}, !ownerState.maxWidth && {
  maxWidth: 'calc(100% - 64px)'
}, ownerState.maxWidth === 'xs' && {
  maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
  [`&.${_dialogClasses__WEBPACK_IMPORTED_MODULE_6__/* ["default"].paperScrollBody */ .Z.paperScrollBody}`]: {
    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
  maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
  [`&.${_dialogClasses__WEBPACK_IMPORTED_MODULE_6__/* ["default"].paperScrollBody */ .Z.paperScrollBody}`]: {
    [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.fullWidth && {
  width: 'calc(100% - 64px)'
}, ownerState.fullScreen && {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: 'none',
  borderRadius: 0,
  [`&.${_dialogClasses__WEBPACK_IMPORTED_MODULE_6__/* ["default"].paperScrollBody */ .Z.paperScrollBody}`]: {
    margin: 0,
    maxWidth: '100%'
  }
}));

/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */
const Dialog = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Dialog(inProps, ref) {
  const props = (0,_DefaultPropsProvider__WEBPACK_IMPORTED_MODULE_10__/* .useDefaultProps */ .i)({
    props: inProps,
    name: 'MuiDialog'
  });
  const theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      'aria-describedby': ariaDescribedby,
      'aria-labelledby': ariaLabelledbyProp,
      BackdropComponent,
      BackdropProps,
      children,
      className,
      disableEscapeKeyDown = false,
      fullScreen = false,
      fullWidth = false,
      maxWidth = 'sm',
      onBackdropClick,
      onClick,
      onClose,
      open,
      PaperComponent = _Paper__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
      PaperProps = {},
      scroll = 'paper',
      TransitionComponent = _Fade__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
      transitionDuration = defaultTransitionDuration,
      TransitionProps
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(props, _excluded);
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props, {
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth,
    scroll
  });
  const classes = useUtilityClasses(ownerState);
  const backdropClick = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const handleMouseDown = event => {
    // We don't want to close the dialog when clicking the dialog content.
    // Make sure the event starts and ends on the same DOM element.
    backdropClick.current = event.target === event.currentTarget;
  };
  const handleBackdropClick = event => {
    if (onClick) {
      onClick(event);
    }

    // Ignore the events not coming from the "backdrop".
    if (!backdropClick.current) {
      return;
    }
    backdropClick.current = null;
    if (onBackdropClick) {
      onBackdropClick(event);
    }
    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const ariaLabelledby = (0,_mui_utils_useId__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(ariaLabelledbyProp);
  const dialogContextValue = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DialogRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(classes.root, className),
    closeAfterTransition: true,
    components: {
      Backdrop: DialogBackdrop
    },
    componentsProps: {
      backdrop: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        transitionDuration,
        as: BackdropComponent
      }, BackdropProps)
    },
    disableEscapeKeyDown: disableEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref,
    onClick: handleBackdropClick,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
      appear: true,
      in: open,
      timeout: transitionDuration,
      role: "presentation"
    }, TransitionProps, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DialogContainer, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(classes.container),
        onMouseDown: handleMouseDown,
        ownerState: ownerState,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DialogPaper, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
          as: PaperComponent,
          elevation: 24,
          role: "dialog",
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledby
        }, PaperProps, {
          className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(classes.paper, PaperProps.className),
          ownerState: ownerState,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_DialogContext__WEBPACK_IMPORTED_MODULE_16__/* ["default"].Provider */ .Z.Provider, {
            value: dialogContextValue,
            children: children
          })
        }))
      })
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Dialog);

/***/ }),

/***/ 434182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

const DialogContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (DialogContext);

/***/ }),

/***/ 477620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getDialogUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils_generateUtilityClasses__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(545154);
/* harmony import */ var _mui_utils_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(922104);


function getDialogUtilityClass(slot) {
  return (0,_mui_utils_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)('MuiDialog', slot);
}
const dialogClasses = (0,_mui_utils_generateUtilityClasses__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
/* harmony default export */ __webpack_exports__["Z"] = (dialogClasses);

/***/ }),

/***/ 281763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(644239),
    isObjectLike = __webpack_require__(637005);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ 680729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_ExitGatingModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(264666);
// EXTERNAL MODULE: ./src/redux/store/index.js + 44 modules
var store = __webpack_require__(167261);
// EXTERNAL MODULE: ./src/config/index.js
var config = __webpack_require__(477733);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
;// CONCATENATED MODULE: ./src/components/ExitGatingModal/components/common/TemplateLayout/index.tsx
// package imports


var TemplateLayout = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex template-container",
        children: props.children
    });
};
/* harmony default export */ var common_TemplateLayout = (TemplateLayout);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
;// CONCATENATED MODULE: ./src/components/ExitGatingModal/components/common/TemplateTextCard/index.tsx
// package imports



// components

// utills and others

var TemplateTextCard = function(props) {
    var logoImage = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : ref.logo_image;
    });
    var type = props.type, greedyMessage = props.greedyMessage, offerText = props.offerText, minOrderValue = props.minOrderValue, maxDiscount = props.maxDiscount, couponName = props.couponName;
    var copyCoupon = function() {
        var copiedText = couponName;
        navigator.clipboard.writeText(copiedText).then(function() {
            (0,Toast/* toastNotifySuccess */.jh)("Coupon copied!");
        }).catch(function(err) {
            console.error("Oops!! Something went wrong!", err);
        });
    };
    var getOfferLimitText = function() {
        var minOrderValueTextOnly = minOrderValue && "Minimum order value ".concat(config/* CURRENCY_SYMBOL */.o).concat(minOrderValue);
        var maxDiscountTextOnly = maxDiscount && "Maximum discount ".concat(config/* CURRENCY_SYMBOL */.o).concat(maxDiscount);
        var bothText = minOrderValue && maxDiscount && "".concat(minOrderValueTextOnly, ", ").concat(maxDiscountTextOnly);
        return bothText || maxDiscountTextOnly || minOrderValueTextOnly || "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-column justify-center items-center w-100 h-100 z-1 sticky text-card text-card-".concat(type),
        children: [
            !!logoImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: logoImage,
                className: "logo-image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "tempting-message",
                children: greedyMessage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "flex flex-column justify-center items-center tc offer-info",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "offer-text",
                        children: offerText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "offer-limit",
                        children: getOfferLimitText()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-column coupon-button-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center w-100 coupon-name",
                        children: couponName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "copy-coupon-button",
                        onClick: copyCoupon,
                        children: "Copy code"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var common_TemplateTextCard = (TemplateTextCard);

;// CONCATENATED MODULE: ./src/components/ExitGatingModal/components/BgImageTemplate/index.tsx
// package imports




// components


var BgImageTemplate = function(props) {
    var imgUrl = props.imgUrl, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "imgUrl"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TemplateLayout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-100 h-100 cover bg-center relative",
            style: {
                backgroundImage: "url(".concat(imgUrl, ")")
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute absolute--fill o-50 bg-gradient"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute absolute--fill",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TemplateTextCard, (0,_object_spread/* default */.Z)({
                        type: "bg-img"
                    }, restProps))
                })
            ]
        })
    });
};
/* harmony default export */ var components_BgImageTemplate = (BgImageTemplate);

;// CONCATENATED MODULE: ./src/components/ExitGatingModal/components/SideImageTemplate/index.tsx
// package imports




// components


var SideImageTemplate = function(props) {
    var imgUrl = props.imgUrl, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "imgUrl"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_TemplateLayout, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-50 h-100 cover bg-center",
                style: {
                    backgroundImage: "url(".concat(imgUrl, ")")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-50 h-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TemplateTextCard, (0,_object_spread/* default */.Z)({
                    type: "side-img"
                }, restProps))
            })
        ]
    });
};
/* harmony default export */ var components_SideImageTemplate = (SideImageTemplate);

;// CONCATENATED MODULE: ./src/components/ExitGatingModal/components/NoImageTemplate/index.tsx
// package imports



// components


var NoImageTemplate = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TemplateLayout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TemplateTextCard, (0,_object_spread/* default */.Z)({
            type: "no-img"
        }, props))
    });
};
/* harmony default export */ var components_NoImageTemplate = (NoImageTemplate);

;// CONCATENATED MODULE: ./src/components/ExitGatingModal/components/index.tsx




;// CONCATENATED MODULE: ./src/components/ExitGatingModal/constants/index.ts
var PERCENTAGE_DISCOUNT_TYPE_CONSTANT = 1;
var EXIT_GATING_DEFAULT_IMG_URL = "https://cdn.dotpe.in/longtail/gif/76/036EtrqP.jpeg";
var EXIT_GATING_TEMPLATE_TYPE = {
    BG_IMG: "bg-img",
    SIDE_IMG: "side-img",
    NO_IMG: "no-img"
};
var EXIT_GATING_GREEDY_MESSAGE = {
    BG_IMG: "Stop! Here's a Surprise",
    NO_IMG: "Wait! You're Leaving Empty-Handed",
    SIDE_IMG: "Don’t go away, here's a surprise!"
};
var EXIT_GATING_CONFIG_KEY = "exitGatingCofig";

// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(644779);
;// CONCATENATED MODULE: ./src/components/ExitGatingModal/utils/index.tsx







var getTemplateGreedyMessage = function(templateType) {
    var BG_IMG = EXIT_GATING_TEMPLATE_TYPE.BG_IMG, SIDE_IMG = EXIT_GATING_TEMPLATE_TYPE.SIDE_IMG;
    switch(templateType){
        case BG_IMG:
            return EXIT_GATING_GREEDY_MESSAGE.BG_IMG;
        case SIDE_IMG:
            return EXIT_GATING_GREEDY_MESSAGE.SIDE_IMG;
        default:
            return EXIT_GATING_GREEDY_MESSAGE.NO_IMG;
    }
};
var getTemplateOfferText = function(couponData) {
    var isCouponPercentType = (couponData === null || couponData === void 0 ? void 0 : couponData.discount_type) === PERCENTAGE_DISCOUNT_TYPE_CONSTANT;
    return "GET ".concat(isCouponPercentType ? "".concat(couponData === null || couponData === void 0 ? void 0 : couponData.discount, "%") : "FLAT ".concat(config/* CURRENCY_SYMBOL */.o).concat(couponData === null || couponData === void 0 ? void 0 : couponData.discount), "  OFF");
};
var getTemplateInfo = function(templateType) {
    var exitGatingData = store/* default.getState */.Z.getState().commonReducer.exitGatingData;
    var imgUrl = (exitGatingData === null || exitGatingData === void 0 ? void 0 : exitGatingData.imagePath) || EXIT_GATING_DEFAULT_IMG_URL;
    var couponData = exitGatingData === null || exitGatingData === void 0 ? void 0 : exitGatingData.couponData;
    var shouldIncludeImg = templateType !== EXIT_GATING_TEMPLATE_TYPE.NO_IMG;
    var commonInfo = {
        greedyMessage: getTemplateGreedyMessage(templateType),
        offerText: getTemplateOfferText(couponData),
        minOrderValue: couponData === null || couponData === void 0 ? void 0 : couponData.min_order_price,
        maxDiscount: couponData === null || couponData === void 0 ? void 0 : couponData.max_discount,
        couponName: (couponData === null || couponData === void 0 ? void 0 : couponData.promo_code) || ""
    };
    return shouldIncludeImg ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonInfo), {
        imgUrl: imgUrl
    }) : commonInfo;
};
var getTemplateByType = function(templateType) {
    var BG_IMG = EXIT_GATING_TEMPLATE_TYPE.BG_IMG, SIDE_IMG = EXIT_GATING_TEMPLATE_TYPE.SIDE_IMG;
    switch(templateType){
        case BG_IMG:
            return components_BgImageTemplate;
        case SIDE_IMG:
            return components_SideImageTemplate;
        default:
            return components_NoImageTemplate;
    }
};
var getLocalExitGatingConfig = function() {
    return LocalStorageHelper/* default.get */.Z.get(EXIT_GATING_CONFIG_KEY);
};
var setLocalExitGatingConfig = function(data) {
    return LocalStorageHelper/* default.add */.Z.add(EXIT_GATING_CONFIG_KEY, data);
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(450594);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var isNumber = __webpack_require__(281763);
var isNumber_default = /*#__PURE__*/__webpack_require__.n(isNumber);
;// CONCATENATED MODULE: ./src/components/ExitGatingModal/index.tsx












var ExitGatingModal = function() {
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            exitGatingData: state.commonReducer.exitGatingData,
            storeId: state.storeReducer.store.store_id
        };
    }), _exitGatingData = ref.exitGatingData, selectedTemplate = _exitGatingData.selectedTemplate, status = _exitGatingData.status, minUserTimeSpent = _exitGatingData.minUserTimeSpent, perDayPopUpLimit = _exitGatingData.perDayPopUpLimit, storeId = ref.storeId;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(null), timerId = ref1[0], setTimerId = ref1[1];
    var ref2 = (0,react.useState)({
        totalPopUpsShown: null,
        timeSpent: null,
        date: new Date().toDateString()
    }), exitGatingConfig = ref2[0], setExitGatingConfig = ref2[1];
    var perDayPopUpLimitReached = exitGatingConfig.totalPopUpsShown >= perDayPopUpLimit;
    var ref3 = (0,react.useState)(false), showModal = ref3[0], setShowModal = ref3[1];
    var ref4 = (0,react.useState)(false), modalCanBeShown = ref4[0], setModalCanBeShown = ref4[1];
    var isBgImgTypeModal = selectedTemplate === EXIT_GATING_TEMPLATE_TYPE.BG_IMG;
    var Template = getTemplateByType(selectedTemplate);
    (0,react.useEffect)(function() {
        document.body.addEventListener("mouseleave", handleOnMouseLeave);
        return function() {
            document.body.removeEventListener("mouseleave", handleOnMouseLeave);
        };
    }, [
        modalCanBeShown,
        exitGatingConfig.totalPopUpsShown
    ]);
    (0,react.useEffect)(function() {
        handleIntialData();
        return function() {
            stopTimer();
        };
    }, [
        status,
        storeId
    ]);
    (0,react.useEffect)(function() {
        checkIfModalCanBeShown();
        return function() {
            saveConfigInLocal();
        };
    }, [
        exitGatingConfig.timeSpent,
        exitGatingConfig.totalPopUpsShown
    ]);
    // checks if the modal can be shown on webpage on mouse leave
    var checkIfModalCanBeShown = function() {
        var timeSpent = exitGatingConfig.timeSpent;
        if (!perDayPopUpLimitReached) {
            if (timeSpent > minUserTimeSpent * 60) {
                setModalCanBeShown(true);
            } else {
                modalCanBeShown && setModalCanBeShown(false);
            }
        } else {
            saveConfigInLocal();
            stopTimer();
        }
    };
    var saveConfigInLocal = function() {
        return isNumber_default()(exitGatingConfig.timeSpent) && isNumber_default()(exitGatingConfig.totalPopUpsShown) && setLocalExitGatingConfig(exitGatingConfig);
    };
    // Action when mouse leaves the webpage
    var handleOnMouseLeave = function() {
        if (modalCanBeShown && !perDayPopUpLimitReached) {
            setShowModal(true);
            setExitGatingConfig(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    totalPopUpsShown: state.totalPopUpsShown + 1,
                    timeSpent: 0
                });
            });
            setModalCanBeShown(false);
        }
    };
    // handle initial data for exit Gating
    var handleIntialData = function() {
        if (!status) {
            storeId && dispatch((0,common/* getExitGatingData */.qm)(storeId));
        } else {
            var localExitGatingConfig = getLocalExitGatingConfig();
            if ((localExitGatingConfig === null || localExitGatingConfig === void 0 ? void 0 : localExitGatingConfig.date) === exitGatingConfig.date) {
                setExitGatingConfig(function(state) {
                    return (0,_object_spread/* default */.Z)({}, state, localExitGatingConfig);
                });
            } else {
                setExitGatingConfig(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        totalPopUpsShown: 0,
                        timeSpent: 0
                    });
                });
            }
            !timerId && startTimer();
        }
    };
    // Start the timmer
    var startTimer = function() {
        if (timerId) {
            clearInterval(timerId);
        }
        var thisTimerId = setInterval(function() {
            setExitGatingConfig(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    timeSpent: state.timeSpent + 1
                });
            });
        }, 1000);
        setTimerId(thisTimerId);
    };
    // stop the timer
    var stopTimer = function() {
        if (timerId) {
            clearInterval(timerId);
            setTimerId(null);
        }
    };
    var toggleModal = function() {
        return setShowModal(!showModal);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: showModal,
        PaperProps: {
            style: {
                padding: "0px",
                borderRadius: "0px"
            }
        },
        maxWidth: "lg",
        onClose: toggleModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative h-100 w-100",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Close["default"], {
                    className: "absolute right-1 top-1 exit-modal-close-icon ".concat(isBgImgTypeModal ? "exit-modal-close-icon-white" : ""),
                    onClick: toggleModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Template, (0,_object_spread/* default */.Z)({}, getTemplateInfo(selectedTemplate)))
            ]
        })
    });
};
/* harmony default export */ var components_ExitGatingModal = (ExitGatingModal);


/***/ })

}]);